// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1U5Db","search":"Settings_search__3GNxK","filter":"Settings_filter__2zNzu"};